import { render, staticRenderFns } from "./LiuShuiXianKanban.vue?vue&type=template&id=d5d92b56"
import script from "./LiuShuiXianKanban.vue?vue&type=script&lang=js"
export * from "./LiuShuiXianKanban.vue?vue&type=script&lang=js"
import style0 from "./LiuShuiXianKanban.vue?vue&type=style&index=0&id=d5d92b56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports